import React from "react";
import Day from "./Day";
import styled from "styled-components";

export default function Month({ month, setOpenHearing }) {
  return (
    <MonthContainer>
      {month.map((row, i) => (
        <React.Fragment key={i}>
          {row.map((day, idx) => (
            <Day
              day={day}
              key={idx}
              rowIdx={i}
              setOpenHearing={setOpenHearing}
            />
          ))}
        </React.Fragment>
      ))}
    </MonthContainer>
  );
}

const MonthContainer = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  border-radius: 16px;
  margin: 1rem;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #00838c 0%, #00a8b5 100%);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #00a8b5 0%, #00c5d3 100%);
  }

  scrollbar-width: thin;
  scrollbar-color: #00838c rgba(0, 0, 0, 0.05);
`;
